import { inject, NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, RouterModule, RouterStateSnapshot, Routes } from '@angular/router';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { UserInfoResolver } from './resolvers/user-info.resolver';
import { LookupsResolver } from './resolvers/lookups.resolver';
import { CustomMsalGuard } from './guards/custom-msal.guard';

const routes: Routes = [{ path: '', redirectTo: 'projects', pathMatch: 'full' },
  { path: 'projects', canActivate: [CustomMsalGuard], resolve: {
                                                            'userInfo': (route: ActivatedRouteSnapshot) => inject(UserInfoResolver).resolve(route),
                                                            'lookups':  (route: ActivatedRouteSnapshot) => inject(LookupsResolver).resolve(route)
                                                         },
                                                loadChildren: () => import('../projects/projects.module').then(m => m.ProjectsModule) },
  { path: 'auth', component: MsalRedirectComponent },
  //{ path: "**", redirectTo: "not-found" }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
